import { ChangeDetectorRef, Component, inject, PLATFORM_ID } from '@angular/core';
import { DocumentSpecificSearchService } from '../document-specific-search.service';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Subscription } from 'rxjs';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { KBLanguageService } from 'src/app/services/sapSpartacus/kbLanguageService/KbLang-service.service';
import { FileDownloadService } from '@spartacus/storefront';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-favourites-listing-page',
  templateUrl: './favourites-listing-page.component.html',
  styleUrls: ['./favourites-listing-page.component.scss'],
  standalone: false
})
export class FavouritesListingPageComponent {
  apiloaded: boolean = false;
  sortPayload: any
  isMobile: boolean = false;

  userList: any;
  currentPage: number = 0;
  pageSize: number = 10;
  sub = new Subscription();

  avoidPageLoadCall: boolean = false;
  // creating variables forsorting the table with arrows
  sortByDocNo: string = undefined;
  sortByDesc: string = undefined;
  sortByDocType: string = undefined;
  platformId = inject(PLATFORM_ID);


  constructor(private breakpointObserver: BreakpointObserver,
    private service: DocumentSpecificSearchService,
    private cdr: ChangeDetectorRef,
    private globalmsgService: GlobalMessageService,
    private langservice: KBLanguageService,
    private fileDownloadService: FileDownloadService
  ) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }
  ngOnInit() {
    if (this.isMobile) {
      this.setCustomWidth();
    }
    this.callApi(0, 10);
  }
  ngAfterViewInit() {
    this.sub.add(this.langservice.getActive().subscribe((lang: any) => {
      if (this.avoidPageLoadCall) {
        this.callApi(this.currentPage, this.pageSize);
      }
    }));
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth - 10;
      document.documentElement.style.setProperty('--custom-table-width', `${widthInPixels}px`);
    }
  }
  callApi(currPage, size, sort?) {
    this.currentPage = currPage;
    this.pageSize = size;
    this.sub.add(this.service.myFavDocListPage(currPage, size, this.sortPayload?.type ?? 'byDocumentDescription').subscribe((data: any) => {
      this.userList = data;
      this.apiloaded = true;
      this.avoidPageLoadCall = true;
      this.cdr.detectChanges();
    }))
  }
  unSubscribeDoc(doc: any) {
    this.sub.add(this.service.removeDocandUnsubscribe(doc).subscribe((res: any) => {
      if (res.status == 'success') {
        this.callApi(0, 10);
      }
    }));
  }
  SubscribeDoc(data: any, langIso) {
    this.sub.add(this.service.getDownloadPopup().subscribe((response: any) => {
      const payLoad = {
        code: data.code,
        email: response.displayUid,
        name: response.name,
        revision: data.revision,
        language: langIso
      }
      this.sub.add(this.service.postSubscribe(payLoad).subscribe((res: any) => {
        if (res.status == 'success') {
          this.globalmsgService.add({ key: 'common.text_notification_for_confirm_subscription' }, GlobalMessageType.MSG_TYPE_INFO);
        }
      }));
    }));
  }

  changePageCustom(e, data) {
    this.callApi(e, 10);
  }

  sort(type) {
    if (type == 'byDocumentNumber') {
      if (this.sortByDocNo == 'asc') {
        this.sortByDocNo = 'desc';
      } else if (this.sortByDocNo == 'desc') {
        this.sortByDocNo = 'asc';
      } else {
        this.sortByDocNo = 'desc';
      }
      this.removeOtherSorts(type, this.sortByDocNo);
    }
    else if (type == 'byDocumentDescription') {
      if (this.sortByDesc == 'asc') {
        this.sortByDesc = 'desc';
      } else if (this.sortByDesc == 'desc') {
        this.sortByDesc = 'asc';
      } else {
        this.sortByDesc = 'desc';
      }
      this.removeOtherSorts(type, this.sortByDesc);
    }
    else if (type == 'byDocumentType') {
      if (this.sortByDocType == 'asc') {
        this.sortByDocType = 'desc';
      } else if (this.sortByDocType == 'desc') {
        this.sortByDocType = 'asc';
      } else {
        this.sortByDocType = 'desc';
      }
      this.removeOtherSorts(type, this.sortByDocType);
    }

  }

  removeOtherSorts(type, format) {
    if (type == 'byDocumentNumber') {
      this.sortByDesc = undefined;
      this.sortByDocType = undefined;
    } else if (type == 'byDocumentDescription') {
      this.sortByDocNo = undefined;
      this.sortByDocType = undefined;
    } else if (type == 'byDocumentType') {
      this.sortByDesc = undefined;
      this.sortByDocNo = undefined;
    }
    if (format == 'desc') {
      this.sortPayload = { type: type + format };
    } else {
      this.sortPayload = { type: type };
    }
    this.callApi(0, 10, this.sortPayload?.type);
  }
  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  getPdfWithTimestamp(data: any) {
    const payLoadforpdf = {
      url: data.favoriteListEntryDocument.url,
      documentCode: data.favoriteListEntryDocument.code,
      documentLanguage: data.favoriteListEntryDocument.language,
      revision: data.favoriteListEntryDocument.revision,
    }
    this.sub.add(this.service.getTimeStampInPdf(payLoadforpdf).subscribe({
      next: (res: any) => {
        const file = new Blob([res], { type: res.type });
        const url = URL.createObjectURL(file);
        if (isPlatformBrowser(this.platformId)) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.click();}
      
      },
      error: () => {

      },
    }));
  }
}
